"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BellSolid: function() {
        return BellSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const BellSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M3.24827 19H20.7518C21.3393 19 21.7677 18.6391 21.9706 18.2505C22.1714 17.8657 22.2183 17.3322 21.9279 16.8612C21.2941 15.8335 19.9965 13.2169 20 9C20 4.58172 16.4183 1 12 1C7.58171 1 3.99998 4.58256 3.99998 9.00084C4.00351 13.2178 2.70594 15.8335 2.07214 16.8612C1.78171 17.3322 1.82863 17.8657 2.02949 18.2505C2.23229 18.6391 2.66069 19 3.24827 19Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M15.874 20H8.126C8.57004 21.7252 10.1361 23 12 23C13.8638 23 15.4299 21.7252 15.874 20Z",
            fill: "currentColor"
        })
    ]
}), "BellSolid");
const _default = BellSolid;
